/* Copyright 2021, Milkdown by Mirone. */
import { css } from '@emotion/css';
const itemStyle = ({ font, palette }) => {
    return css `
        .slash-dropdown-item {
            display: flex;
            gap: 2rem;
            height: 3rem;
            padding: 0 1rem;
            align-items: center;
            justify-content: flex-start;
            cursor: pointer;
            line-height: 2;
            font-family: ${font.typography};
            font-size: 0.875rem;

            transition: all 0.2s ease-in-out;

            &,
            .icon {
                color: ${palette('neutral', 0.87)};
                transition: all 0.2s ease-in-out;
            }

            &.hide {
                display: none;
            }

            &.active {
                background: ${palette('secondary', 0.12)};
                &,
                .icon {
                    color: ${palette('primary')};
                }
            }
            `;
};
export const injectStyle = (themeTool) => {
    var _a, _b, _c;
    const { mixin, size, palette } = themeTool;
    const style = css `
        width: 20.5rem;
        max-height: 20.5rem;
        overflow-y: auto;
        ${(_a = mixin.border) === null || _a === void 0 ? void 0 : _a.call(mixin)};
        border-radius: ${size.radius};
        position: absolute;
        background: ${palette('surface')};

        ${(_b = mixin.shadow) === null || _b === void 0 ? void 0 : _b.call(mixin)};

        &.hide {
            display: none;
        }

        ${(_c = mixin.scrollbar) === null || _c === void 0 ? void 0 : _c.call(mixin)};

        ${itemStyle(themeTool)}
    `;
    return style;
};
//# sourceMappingURL=style.js.map